import mapFr from '../../../images/map_fr.svg';
import styled from 'styled-components';

export const SelectAddressMapWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;

  & > div {
    height: auto;
    max-width: 50%;
    float: left;
  }
  &::after {
    content: ' ';
    height: auto;
    width: 50%;
    min-height: calc(100vh - 150px);
    display: flex;
    background: url(${mapFr});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center top;
  }
`;

export const SelectAddressWrapperInput = styled.div`
  width: 100%;
`;
